import { DocumentNode, gql } from '@apollo/client';
import { HStack, Stack, StackProps, Text, Wrap } from '@chakra-ui/react';
import * as React from 'react';

import { EventAudience } from '@/components/EventAudience';
import { EventLocation } from '@/components/EventLocation';
import { EventTime } from '@/components/EventTime';
import { CalendarIcon } from '@/imports/ui/chakra/feather';
import { AddToCalendarMenu } from '@/imports/ui/components/event/AddToCalendarMenu';

import { EventScheduleInfo_EventFragment } from './graphql-types/EventScheduleInfo_EventFragment';

export const EventScheduleInfo: React.FC<{
  event: EventScheduleInfo_EventFragment;
  showAddToCalendar?: boolean;
}> & {
  eventFragment: DocumentNode;
} = ({ event, showAddToCalendar }) => {
  return (
    <Stack>
      <Stack direction={{ base: 'column', sm: 'row' }}>
        <Stack direction="row" alignItems="center">
          <CalendarIcon />
          <Text>
            <EventTime startDate={event.startDate} endDate={event.endDate} />
          </Text>
        </Stack>

        {showAddToCalendar && <AddToCalendarMenu eventId={event._id} />}
      </Stack>

      <Stack>
        <EventLocation event={event} />

        <EventAudience event={event} noOfLines={1} />
      </Stack>
    </Stack>
  );
};

EventScheduleInfo.eventFragment = gql`
  fragment EventScheduleInfo_EventFragment on EventV2 {
    startDate
    endDate
    ...EventAudience_EventFragment
    ...EventLocation_EventFragment
  }
  ${EventAudience.eventFragment}
  ${EventLocation.eventFragment}
`;
